<template>
  <q-page class="q-pa-lg page-background">
    <div class="row justify-center">
      <q-card class="frosted col-11 items-center">
        <q-card-section>
          <div class="text-h6">{{ post_data.title }}</div>
          <div class="caption">de {{ post_data.author }}</div>
        </q-card-section>
        <q-separator class="q-mt-md" />
        <q-card-section>
          <div v-html="post_data.content"></div>
        </q-card-section>
        <q-separator class="q-mt-md" />
        <q-card-actions class="row">
          <q-btn flat size="md" color="grey-8" label="Comment" icon="mdi-message-text" @click="comment_create = true" />
          <q-btn v-if="isadmin" flat size="md" color="blue-10" label="Editeaza" icon="mdi-pen" @click="ModifyPost()"/>
          <q-btn v-if="isadmin" flat size="md" color="red-9" label="Sterge" icon="mdi-delete" @click="post_delete=true"/>
        </q-card-actions>
      </q-card>
    </div>
    <div class="q-pt-md"></div>
    <div v-if="post_data.comments != 'empty'" class="row justify-center">
      <div v-for="(comment,index) in post_data.comments" :key="comment" class="q-pa-sm row frosted col-11">
        <q-btn v-if="isadmin" class="q-ml-sm" icon="mdi-dots-horizontal" style="" color="green-10" flat>
          <q-menu auto-close>
            <q-list>
              <q-item clickable @click="Modify(comment.content,comment.id,index)">
                <q-item-section style="width: 50px;">
                  <q-icon color="blue-10" class="q-ml-md" name="mdi-pen">Editeaza</q-icon>
                </q-item-section>
              </q-item>
              <q-item clickable>
                <q-item-section @click="DeleteComment(comment.id)">
                  <q-icon color="red-9" class="q-ml-md" name="mdi-delete">Sterge</q-icon>
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
          <q-tooltip class="bg-green" anchor="center left" self="center right" :offset="[10, 10]">
            Optiuni
          </q-tooltip>
        </q-btn>
        <q-chat-message v-if="comment" :name="comment.author.name" :avatar="comment.author.avatar"
          :text="comment.content" text-html text-color="white" bg-color="blue-9" class="q-pl-md col-12" />
      </div>
      <q-dialog v-model="edit_comment">
        <q-card style="width: 700px; max-width: 80vw">
          <q-card-section>
            <div class="text-h6">Editeaza comentariul</div>
          </q-card-section>
          <q-card-section class="q-pt-none">
            <q-editor v-model="edit_content" min-height="5rem" />
          </q-card-section>
          <q-card-actions align="right">
            <q-btn label="Cancel" color="red" v-close-popup />
            <q-btn label="Post" color="blue-8" @click="ApplyEdit()" v-close-popup />
          </q-card-actions>
        </q-card>
      </q-dialog>
      <q-dialog v-model="editPost">
        <q-card style="width: 700px; max-width: 80vw">
          <q-card-section>
            <div class="text-h6">Editeaza postarea</div>
          </q-card-section>
          <q-card-section class="q-pt-none">
            <q-editor v-model="editPostContent" min-height="5rem" />
          </q-card-section>
          <q-card-actions align="right">
            <q-btn label="Cancel" color="red" v-close-popup />
            <q-btn label="Post" color="blue-8" @click="ApplyPostEdit()" v-close-popup />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>

    <q-dialog v-model="comment_create" persistent>
      <q-card style="width: 700px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">Adauga un comentariu</div>
        </q-card-section>
        <q-card-section class="q-pt-none">
          <q-editor v-model="comment_content" min-height="5rem" />
        </q-card-section>
        <q-card-actions align="right">
          <q-btn label="Cancel" color="red" v-close-popup />
          <q-btn label="Post" color="blue-8" @click="SendComment()" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="post_delete" persistent>
      <q-card style="width: 700px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">Stergi aceasta postare?</div>
        </q-card-section>
        <q-card-section class="q-pt-none">
          <div class="text-body1">Esti sigur ca vrei sa stergi aceasta postare?</div>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn label="Cancel" color="red" v-close-popup />
          <q-btn label="Sterge" color="blue-8" @click="DeletePost()" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
    
  </q-page>
</template>

<style>
.page-background {
  background-image: url("../assets/forest.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.frosted {
  background: rgba(255, 255, 255, 0.678);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  border: 3px solid rgba(255, 255, 255, 0.18);
}

.comment {
  background: rgba(192, 192, 192, 0.678);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  border: 3px solid rgba(255, 255, 255, 0.18);
}
</style>

<script>
import { ref } from "@vue/reactivity";
import firebase from "firebase";
import { store } from "../store/store";
import { Notify } from "quasar";

export default {
  data() {
    return {
      post_data: store.state.post,
      comment_create: ref(false),
      comment_content: ref(" "),
      isadmin: false,
      edit_comment: false,
      edit_content: "",
      edit_id: "",
      edit_comment_index: 0,
      editPost:false,
      editPostContent:"",
      comment_delete:false,
      post_delete:false,
    };
  },
  methods: {
    ModifyPost(){
      this.editPost = true,
      this.editPostContent = this.post_data.content
    },
    Modify(cont, id, index) {
      this.edit_comment = true
      this.edit_content = cont[0]
      this.edit_id = id
      this.edit_comment_index = index
    },
    GetComments() {
      const comments = [];
      const raw_comments = this.post_data.comments;
      if (raw_comments != "empty") {
        for (let i; i < raw_comments.length; i++) {
          comments.push(raw_comments[i]);
        }
        comments.sort((a, b) => new Date(b.date) - new Date(a.date));
        return comments;
      } else {
        return comments;
      }
    },
    GetUpdatedComments() {
      return new Promise((resolve) => {
        const title = this.post_data.title.toLowerCase().split(" ").join("-");
        firebase
          .database()
          .ref("posts/" + title)
          .get()
          .then((snapshot) => {
            const data = snapshot.val();
            if (data.comments === undefined || data.comments.length == 0) {
              data.comments = [];
              resolve(data.comments);
            } else {
              resolve(
                data.comments.sort(
                  (a, b) => new Date(b.date) - new Date(a.date)
                )
              );
            }
          });
      });
    },
    ApplyEdit() {
      const title = this.post_data.title.toLowerCase().split(" ").join("-");
      firebase.database().ref(`posts/${title}/comments/${this.edit_id}`).update({
        content: [this.edit_content]
      })
      this.post_data.comments[this.edit_comment_index].content = [this.edit_content]
    },
    ApplyPostEdit() {
      const title = this.post_data.title.toLowerCase().split(" ").join("-");
      firebase.database().ref(`posts/${title}/`).update({
        content: [this.editPostContent]
      })
      this.post_data.content = [this.editPostContent]
    },
    DeletePost(){
      const title = this.post_data.title.toLowerCase().split(" ").join("-");
      firebase.database().ref(`posts/${title}`).set({})
      // firebase.database.ref(`posts`).once()
      this.post_data.title = "Aceasta postare a fost stearsa. Vezi alte postari"
      this.post_data.content = "Aceasta postare a fost stearsa. Vezi alte postari"
    },
    DeleteComment(commid) {
      const title = this.post_data.title.toLowerCase().split(" ").join("-");
      this.post_data.comments.splice(commid, 1)
      firebase.database().ref(`posts/${title}/comments`).set(this.post_data.comments)
    },
    SendComment() {
      const user = store.state.user.data;
      if (user) {
        firebase
          .database()
          .ref("users/" + user.uid)
          .get()
          .then((snapshot) => {
            const title = this.post_data.title
              .toLowerCase()
              .split(" ")
              .join("-");
            this.GetUpdatedComments().then((comments) => {
              // console.log("UPDATED COMMMENTS", comments)
              const current_date = new Date();
              const actual_user = snapshot.val();
              let id = 0;
              if (comments !== undefined || comments.length !== 0) {
                id = comments.length;
              }
              let comment;
              if (actual_user !== null) {
                comment = {
                  id: id,
                  author: {
                    name: actual_user.displayName,
                    uid: user.uid,
                    avatar: actual_user.profilepic,
                  },
                  content: [this.comment_content],
                  date: current_date,
                };
              } else {
                comment = {
                  id: id,
                  author: {
                    name: "Anonim",
                    uid: `anonim`,
                    avatar: "https://i.imgur.com/92ibtIJ.png",
                  },
                  content: [this.comment_content],
                  date: current_date,
                };
              }

              comments.push(comment);
              store.commit({
                type: "UPDATE_POST_COMMENTS",
                comments: comments,
              });
              // console.log("STORE COMMENTS", store.state.post.comments)
              firebase
                .database()
                .ref("posts/" + title)
                .update({ comments: comments });
              this.comment_content = "";
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        Notify.create({
          icon: "mdi-alert-circle",
          message: "Este necesara autentificarea pentru a comenta.",
          timeout: 3000,
          color: "red-10",
        });
      }
    },
  },
  mounted() {
    setInterval(() => {
      const user = store.state.user.data
      if (!user) {
        this.isadmin = false
      } else {
        if (user.admin) {
          this.isadmin = user.admin
        }
      }
    }, 1000)
  },
};
</script>